import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';
import ContactCard from '../../../components/ContactCard';
import IconButtonsStack from '../../../components/IconButtonsStack';

const iconButtons = [
  {
    variant: 'icon-default',
    icon: light('phone'),
    size: 'lg',
    tooltipText: 'Call to 555-555-5555',
  },
  {
    variant: 'icon-default',
    icon: light('globe'),
    size: 'lg',
    tooltipText: 'Open website in new tab',
  },
  {
    variant: 'icon-default',
    icon: light('file-pdf'),
    size: 'lg',
  },
];

const contactCards = [
  {
    titleIcon: light('heart-pulse'),
    title: 'Medical',
    img: `${process.env.PUBLIC_URL}/${'cigna.png'}`,
    medicalGroup: 'HMO Plan',
    status: 'enrolled',
    statusIcon: light('circle-check'),
    contactButtons: <IconButtonsStack iconButtons={iconButtons} />,
  },

  {
    titleIcon: light('heart-pulse'),
    title: 'Medical',
    img: `${process.env.PUBLIC_URL}/${'aetna.png'}`,
    medicalGroup: 'Consumer Choice HDHP',
    contactButtons: <IconButtonsStack iconButtons={iconButtons} />,
  },

  {
    titleIcon: light('heart-pulse'),
    title: 'Medical',
    img: `${process.env.PUBLIC_URL}/${'cigna.png'}`,
    medicalGroup: 'PPO Plan',
    contactButtons: <IconButtonsStack iconButtons={iconButtons} />,
  },
];

export type MedicalModalProps = {
  showMedicalModal: boolean;
  handleCloseMedicalModal: () => void;
};

function MedicalModal({
  showMedicalModal,
  handleCloseMedicalModal,
}: MedicalModalProps) {
  return (
    <>
      <Modal
        className={'p-0'}
        show={showMedicalModal}
        onHide={handleCloseMedicalModal}
        dialogClassName="modal-xl"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <ModalHeader
          leftIcon={light('heart-pulse')}
          leftIconVariant={'icon-emphasized'}
        >
          <h4 className="text-sm-20-lg-32">Medical</h4>
        </ModalHeader>
        <Modal.Body>
          <Container className={'p-0'}>
            <Row>
              {contactCards.map((contactCard, idx) => {
                return (
                  <Col key={idx} className={'col-12 col-lg-4 mb-7 mb-lg-10'}>
                    <ContactCard
                      bg={'transperant-with-border'}
                      title={contactCard.title}
                      titleIcon={contactCard.titleIcon}
                      img={contactCard.img}
                      medicalGroup={contactCard.medicalGroup}
                      status={contactCard.status}
                      statusIcon={contactCard.statusIcon}
                      contactButtons={contactCard.contactButtons}
                    />
                  </Col>
                );
              })}
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-0'}>
          <Button
            variant="primary-outline"
            onMouseDown={handleCloseMedicalModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MedicalModal;
